module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/does-vux-support-weex-44.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/faq/does-vux-support-weex.md
// module id = 746
// module chunks = 442